import * as THREE from "three";

export const GRID_EXTENT = 240;
const GRID_STEP = 1;
const GRID_COLOR = 0x45616a;
const GRID_CENTER_COLOR = 0x8fb4bd;

export type GridPlane = "xy" | "xz" | "yz";

export function createGridPlane(plane: GridPlane): THREE.Group {
  const group = new THREE.Group();
  group.add(
    new THREE.LineSegments(
      createGridGeometry(plane, false),
      new THREE.LineBasicMaterial({
        color: GRID_COLOR,
        transparent: true,
        opacity: 0.42,
      }),
    ),
    new THREE.LineSegments(
      createGridGeometry(plane, true),
      new THREE.LineBasicMaterial({
        color: GRID_CENTER_COLOR,
        transparent: true,
        opacity: 0.72,
      }),
    ),
  );
  return group;
}

function createGridGeometry(
  plane: GridPlane,
  center: boolean,
): THREE.BufferGeometry {
  const positions: number[] = [];
  for (let i = -GRID_EXTENT; i <= GRID_EXTENT; i += GRID_STEP) {
    if ((i === 0) !== center) continue;
    pushGridLine(positions, plane, -GRID_EXTENT, i, GRID_EXTENT, i);
    pushGridLine(positions, plane, i, -GRID_EXTENT, i, GRID_EXTENT);
  }

  const geometry = new THREE.BufferGeometry();
  geometry.setAttribute(
    "position",
    new THREE.Float32BufferAttribute(positions, 3),
  );
  return geometry;
}

function pushGridLine(
  positions: number[],
  plane: GridPlane,
  a1: number,
  a2: number,
  b1: number,
  b2: number,
): void {
  if (plane === "xy") positions.push(a1, a2, 0, b1, b2, 0);
  if (plane === "xz") positions.push(a1, 0, a2, b1, 0, b2);
  if (plane === "yz") positions.push(0, a1, a2, 0, b1, b2);
}
